module.exports = __webpack_public_path__ + "d4805b2132c55484d55a455652c359e1.png";